import PropTypes from "prop-types"
import { Text } from "@planningcenter/tapestry-react"
import moment from "moment-timezone"

import Icon from "components/planning_center_icon"

import { pluralize } from "utils/helpers"

const CheckInsIntegration = ({ sessions, checkInsSettingsPath }) => {
  const upcomingSessions = sessions.filter(s => moment(s.showsAt).isAfter(moment()))
  return (
    <div className="mt-4p line p-2" style={{ maxWidth: 280, whiteSpace: "normal" }}>
      <div className="d-f ai-c tt-u fw-500 pb-1">
        <span
          style={{ color: "var(--t-fill-color-product-checkins-base)" }}
          className="pr-4p p-r t-2p"
        >
          <Icon symbol="check-ins#check" />
        </span>
        Check In
      </div>
      <div className="pb-1">
        {upcomingSessions.length > 0 ? (
          <Text>
            You have {upcomingSessions.length} upcoming Check-Ins{" "}
            {pluralize("session", "sessions", upcomingSessions.length, false)}
          </Text>
        ) : (
          <Text>All Check-Ins sessions are complete</Text>
        )}
      </div>
      <a href={checkInsSettingsPath} id="update-settings">
        Update settings
      </a>
    </div>
  )
}

CheckInsIntegration.propTypes = {
  sessions: PropTypes.array.isRequired,
  checkInsSettingsPath: PropTypes.string.isRequired
}

export default CheckInsIntegration
